import PoliciesModal from './PoliciesModal';

export default PoliciesModal;
